import { BrowserRouter } from 'react-router-dom';
import { AppRoutes } from './router';
import { CurrencyProvider } from './contexts/CurrencyContext';
import { AuthProvider } from './contexts/AuthContext';
import { FormationModeProvider } from './contexts/FormationModeContext';
import ScrollToTop from './components/feature/ScrollToTop';
import ScrollToTopButton from './components/feature/ScrollToTopButton';
import WhatsAppFAB from './components/feature/WhatsAppFAB';
import SplashScreen from './components/feature/SplashScreen';

function AppContent() {
  return (
    <>
      <SplashScreen />
      <ScrollToTop />
      <ScrollToTopButton />
      <WhatsAppFAB />
      <AppRoutes />
    </>
  );
}

function App() {
  return (
    <BrowserRouter basename={__BASE_PATH__}>
      <AuthProvider>
        <CurrencyProvider>
          <FormationModeProvider>
            <AppContent />
          </FormationModeProvider>
        </CurrencyProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;